<ng-container [formGroup]="service.formGroup">
  <textarea
    *ngIf="question.type === questionType.LongResponse"
    class="form-control"
    rows="3"
    [maxLength]="question.getMaxCharacterLimitForLongResponse()"
    [formControlName]="question.getName()"
  ></textarea>
  <input
    *ngIf="question.type === questionType.ShortResponse"
    [formControlName]="question.getName()"
    [maxLength]="question.getMaxCharacterLimitForShortResponse()"
    [style.width.px]="
      question.getWidthForShortResponse() > 0 ? question.getWidthForShortResponse() : null
    "
  />
</ng-container>
